/**
 * Ответы на два вопроса, которые задаёт код, живущий в обеих схемах входа: «сессия
 * ещё есть?» и «каким токеном её предъявить внешнему потребителю?».
 *
 * Нужны потому, что признак сессии переехал: раньше им был `access_token` в
 * localStorage, теперь — кука `eplex_token`. Проверки `localStorage.getItem`,
 * оставшиеся по коду, на единой авторизации отвечают «сессии нет» всегда: поллинг
 * журнала останавливался на первом же цикле, виджет импорта поставщиков не
 * открывался вовсе (CAB-641).
 */

import { hasAuthSession, readCookie } from "./authBrowserState";
import { AUTH_TOKEN_COOKIE, isSessionTokenValue, stripRoutingPrefix } from "./unifiedAuth";

/** Есть ли сейчас сессия. Признак один — кука; хранилище браузера больше ни при чём. */
export function hasActiveSession(): boolean {
  return hasAuthSession();
}

/**
 * Токен для потребителей, которые собирают запрос сами и куку отправить не могут:
 * встроенные виджеты на другом домене и обращения напрямую к api.eplex.ru.
 *
 * Префикс маршрутизации отрезаем: он лежит СНАРУЖИ токена и нужен только бэкенду
 * ЛК, а api.eplex.ru ждёт сам JWT.
 *
 * Своим запросам ЛК этот токен не нужен — их авторизует кука и перехватчик
 * `apiJwt`. Заголовок, собранный руками, там наоборот вреден: бэкенд отдаёт
 * приоритет заголовку и уступает куке только когда его нет вовсе.
 */
export function apiSessionToken(): string | null {
  const raw = readCookie(AUTH_TOKEN_COOKIE);
  if (!isSessionTokenValue(raw)) return null;

  return stripRoutingPrefix(raw as string);
}
